module.exports = __webpack_public_path__ + "img/help1-4-1.2396d5fc.png";